import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6z"
}), 'FlagSharp');